import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import {environment} from "../../environments/environment";
import {TerritoryService} from "./geolocation/territory.service";
import { XploreItemDTO } from '../shared/object/xplorer-be-parsed-classes';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventService {

  private readonly http: HttpClient = inject(HttpClient);
  private readonly territoryService: TerritoryService = inject(TerritoryService);


  getUpcomingPopularEvents(): Observable<XploreItemDTO[]> {
    let params = this.buildStandardParams();
    return this.http.get<XploreItemDTO[]>(`${environment.API_URL}/events/upcoming` , {params: params});
  }

  private buildStandardParams(noDraft: boolean = true): HttpParams {
    return new HttpParams()
      .set('territoryCode', this.territoryService.getTerritoryCodeFromUrl())
      .set('noDraft', noDraft);
  }
}
